import { Bases } from "./_migrate";
import { UnitProductInfo } from "./units";
import { ShipWeaponFacing } from "./warfleets";

export interface ISelectedUpgrade {
  instanceId: string;
  upgrade: IUpgradeSection;
  option: IUpgradeOption;
}

export type UpgradeVariant = "replace" | "upgrade" | "upgradeRule" | "attachment";

export interface IUpgradeSection {
  id?: string;
  uid?: string;
  label?: string;
  type: "ArmyBookUpgradeSection";
  variant: UpgradeVariant;
  affects?: { type: "any" | "all" | "exactly" | "up to"; value?: number }; // "any" | "all" | number;
  select?: { type: "any" | "all" | "exactly" | "up to"; value?: number }; // "any" | "all" | number;
  targets?: string[];
  model?: boolean;
  options?: IUpgradeOption[];
  isCommandGroup?: boolean;
  isHeroUpgrade?: boolean;
  isLowPrio?: boolean;
  parentPackageUid?: string;
}

export interface IUpgradeOption {
  uid?: string;
  parentSectionId: string;
  costs: { unitId: string; cost: number; exactCost: number; questCost: number }[];
  label: string;
  isModel?: boolean;
  gains: IUpgradeGains[];
  replacedWhat?: string[] | string[][];
  type: "ArmyBookUpgradeOption";
  proposedCostHint?: {
    unitName: string;
    newCostPrecise: string;
    newCostRounded: number;
    error: UpgradeError;
  }[];
  parentPackageUid?: string;
}

export enum GainType {
  Rule = "ArmyBookRule",
  Weapon = "ArmyBookWeapon",
  Item = "ArmyBookItem"
}

export interface IUpgradeGains {
  id: string;
  name: string;
  label?: string;
  count?: number;
  originalCount?: number;
  type: GainType;
  dependencies?: IUpgradeDependency[];
  isModel?: boolean;
  melee?: boolean;
}

export interface IUpgradeGainsItem extends IUpgradeGains {
  type: GainType.Item;
  name: string;
  content: IUpgradeGains[];
  bases?: Bases;
  product?: UnitProductInfo;
}

export interface IUpgradeGainsWeapon extends IUpgradeGains {
  type: GainType.Weapon;
  attacks: number;
  attacksMultiplier?: number;
  range: number;
  specialRules: IUpgradeGainsRule[];
  weaponId?: string;
  facing?: ShipWeaponFacing; // Warfleets
}

export interface IUpgradeGainsRule extends IUpgradeGains {
  type: GainType.Rule;
  //condition: string;
  rating?: string;
}

export interface IUpgradePackage {
  hint: string;
  uid: string;
  sections: IUpgradeSection[];
  calcErrors?: boolean;
  calcErrorReason?: UpgradeError;
  sync?: any;
}

export interface IUpgradeDependency {
  upgradeInstanceId: string;
  count: number;
  variant: UpgradeVariant;
}

export enum UpgradeError {
  Unknown = 0,
  Negative = 1 << 0, // 1
  Prerequisites = 1 << 1, // 2
  Error = 1 << 2, // 4
  Free = 1 << 3 // 8
}
